import { content } from '../config/content';

export const useContent = (feature) => {
  const location = process.env.REACT_APP_LOCATION;
  const language = localStorage.getItem('userLanguage') || 'English';
  
  // Simply return the exact match, no fallback
  return content[feature]?.[location]?.[language];
};